import React from 'react';
import AppChip from '@/ui/components/AppChip';
import type { BadgeVariant } from '@/ui/theme/colors';

export type InfoChipVariant = 'role' | 'workspace' | 'plan' | 'status' | 'warning';

type Props = {
  variant?: InfoChipVariant;
  children: React.ReactNode;
  className?: string;
  title?: string;
};

const VARIANT_MAP: Record<InfoChipVariant, BadgeVariant> = {
  role: 'accent',
  workspace: 'neutral',
  plan: 'info',
  status: 'success',
  warning: 'warning',
};

export default function InfoChip({
  variant = 'workspace',
  children,
  className,
  title,
}: Props) {
  return (
    <AppChip
      size="sm"
      variant={VARIANT_MAP[variant]}
      label={children}
      className={className}
      title={title}
    />
  );
}
